import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

// ─── Add numbers to a company's Stripe subscription ──────────────────────────

interface AddNumbersPayload {
  company_id: string;
  /** Company API key for security validation */
  company_api_key: string;
  /** One entry per number to order — the backend auto-assigns phone numbers */
  items: Array<{ plan_id: string }>;
  /** Optional: UID of the user to auto-assign to the new subscriptions */
  user_uid?: string;
  /** Optional: User's personal phone (used as number redirection) */
  user_phone?: string;
}

interface AddNumbersResponse {
  created_subscriptions: string[];
}

/**
 * Add numbers to the company's Stripe subscription.
 * Creates a new subscription if none exists, or updates the existing one.
 * Phone numbers are automatically assigned from the available pool.
 */
export async function addNumbersToSubscription(
  payload: AddNumbersPayload,
  auth: Authentication,
): Promise<AddNumbersResponse> {
  try {
    const { company_api_key, ...body } = payload;
    const response = await HttpClient.post(
      '/leedflow/stripe/subscription/add-numbers',
      body,
      auth.token,
      false,
      {
        'x-api-key': company_api_key,
        'x-user-uid': auth.id,
      },
    );
    return response.data;
  } catch (e) {
    console.error('addNumbersToSubscription error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new AddNumbersFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new AddNumbersFailure(e.message);
    }
    return Promise.reject(e);
  }
}

// ─── Failure class ────────────────────────────────────────────────────────────

export class AddNumbersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
